import React, { Dispatch, SetStateAction } from "react"
import { Container, Wrapper, FallbackButtonWrapper } from "./FallbackOrderAction.styled"
import { ReactComponent as WaitingIcon } from "images/icons/hourglass-clock.svg"
import SecondaryButton from "../../Ui/Buttons/SecondaryButton"

type Props = {
  action?: Dispatch<SetStateAction<boolean>>
}

const FallbackOrderAction = ({action}: Props) => {
  return (
    <Container>
      <Wrapper>
        <WaitingIcon />
        <div>Needs to be finalized by admin</div>
      </Wrapper>
      {action && <FallbackButtonWrapper>
        <SecondaryButton handleClick={() => action(false)}>Back to draft</SecondaryButton>
      </FallbackButtonWrapper>}
    </Container>
  )
}

export default FallbackOrderAction
